import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative overflow-hidden bg-brand-navy sun-rays" data-testid="page-hero">
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/85 to-brand-navy/40" />
      </div>
    )}
    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-xs font-bold uppercase tracking-[0.25em] text-brand-orange"
      >
        {eyebrow}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65, delay: 0.1 }}
        className="mt-3 max-w-3xl font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, delay: 0.2 }}
          className="mt-4 max-w-2xl text-base sm:text-lg text-white/70"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
